import { EntityState } from '../../store/store.utils';
import { Application } from '../../../../common/models/application.interface';
import { RbacUserPermissions } from '../../../../common/models/rbac.interface';

export interface UtilState {
    ui: {
        loading: boolean;
    };
    data: {
        application: EntityState<string, Application>;
        rbacPermissions: RbacUserPermissions;
        genericAppData: {
            maintenanceMode?: boolean;
            maintenanceModeDisplayMssg?: string;
        };
    };
}

export const initialUtilState = {
    ui: {
        loading: false
    },
    data: {
        application: {
            idMap: {},
            idSort: []
        },
        rbacPermissions: {},
        genericAppData: {
            maintenanceMode: false,
            maintenanceModeDisplayMssg: ''
        }
    }
};
